"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Trash() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: _BaseTheme.default.colors.gray,
    d: "M16.312 0c-2.879 0-5.248 2.366-5.248 5.244V7.38H3.4a1.556 1.556 0 00-1.556 1.556A1.556 1.556 0 003.4 10.492h2.132v24.264c0 2.878 2.37 5.244 5.248 5.244h18.44c2.878 0 5.248-2.366 5.248-5.244V10.492H36.6a1.556 1.556 0 001.556-1.556A1.556 1.556 0 0036.6 7.38h-7.664V5.244c0-2.878-2.37-5.244-5.248-5.244zm0 3.112h7.376a2.11 2.11 0 012.136 2.132V7.38H14.176V5.244a2.11 2.11 0 012.136-2.132zm-7.668 7.38H31.356v24.264a2.11 2.11 0 01-2.136 2.132H10.78a2.111 2.111 0 01-2.136-2.132zm7.668 6.108a1.556 1.556 0 00-1.556 1.556V29.22a1.556 1.556 0 001.556 1.556 1.556 1.556 0 001.556-1.556V18.156a1.556 1.556 0 00-1.556-1.556zm7.376 0a1.556 1.556 0 00-1.556 1.556V29.22a1.556 1.556 0 001.556 1.556 1.556 1.556 0 001.556-1.556V18.156a1.556 1.556 0 00-1.556-1.556z"
  }));
}

var _default = Trash;
exports.default = _default;